import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, DataBindingDirective } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings, Info } from '../../../../../../../core/common';
import { ProductSampleFulfillmentService } from '../../../../../../../core/services/product-sample-fulfillment.service';
import { UserService } from '../../../../../../../core/services/user.service';
import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotifyType } from '../../../../../../../core/enums/NotifyType';
import { AppNotifyService } from '../../../../../../../core/services/app-notify.service';
import { formatDate } from '@angular/common';
import { CommonService } from '../../../../../../../core/services/common.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as _ from "lodash";
import { IGetFilterSampleBudgetReport } from '../../../../../../../core/models';
@Component({
  selector: 'app-budget-report',
  templateUrl: './budget-report.component.html',
  styleUrls: ['./budget-report.component.scss']
})
export class BudgetReportComponent implements OnInit {
  budgetReportHeaderForm: FormGroup;
  budgetReportHeaderGridData: GridDataResult;
  totalbudgetReportGridData: any[] = [];
  budgetReportGridData: any[] = [];
  budgetReportLoading: boolean;
  loadingPDF: boolean;
  loadingExcel: boolean;
  isonlybudgetReport: boolean;
  isInActivebudgetReport: boolean;
  filterValidateMessage: boolean;
  protected budgetReportLblText = {
    budgetlbl: 'Budget',
    costlbl: 'Cost',
    exportToExcelLbl: 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    sampleProductLbl: 'Sample Request Budget Report',
    startDateLbl: 'Start Date',
    endDateLbl: 'End Date',
    filterlbl: 'Filter',
    infoMessageLbl: 'Please Select Start Date and End Date',
  };
  constructor(private formBuilder: FormBuilder, private router: Router,
    private userService: UserService, private productSampleFulfillmentService: ProductSampleFulfillmentService,
    private appNotifyService: AppNotifyService, private commonService: CommonService,
  ) { }

  ngOnInit() {
    this.initializeFormControls();
    this.getFilterbudgetReportHeader();      
  }
  initializeFormControls() {
    this.budgetReportHeaderForm = this.formBuilder.group({
      startDate: new FormControl(),
      endDate: new FormControl(),
    });
    let todaysDate = new Date();
    let priorDate = new Date(new Date().setDate(todaysDate.getDate() - 30));
    this.budgetReportHeaderForm.controls.startDate.setValue(priorDate);
    this.budgetReportHeaderForm.controls.endDate.setValue(todaysDate);
  }

  getFilterbudgetReportHeader() {
    this.filterValidateMessage = false;
    this.budgetReportLoading = true;
    if (!this.validatebudgetReportHeaderForm()) {
      this.filterValidateMessage = true;
      return;
    }

    var controls = this.budgetReportHeaderForm.controls;
    const body: IGetFilterSampleBudgetReport = {
      startDate: controls.startDate.value,
      endDate: controls.endDate.value
    }
   
    this.productSampleFulfillmentService.getSampleAdminBudgetReport(body).subscribe((response: Array<any>) => {
      if (response) {
      
        this.totalbudgetReportGridData = response;
        this.budgetReportGridData = response;
        //this.productSampleFulfillmentService.setbudgetReportHeaderGridData(this.budgetReportGridData);
        this.loadbudgetReportHeaderGridData();
      }
    }, err => {
      this.appNotifyService.notify(NotifyType.ERROR, 'Sorry an error occured while loading the page.');
    })
    this.budgetReportLoading = false;
  }

  validatebudgetReportHeaderForm() {
    let isValid = true;
    const controls = this.budgetReportHeaderForm.controls;
    if (controls.startDate.value) {
      //this.finishSampleLbl.isEmptySubCategory = false;
    } else {
      //this.finishSampleLbl.isEmptySubCategory = true;
      isValid = false;
    }
    if (controls.endDate.value) {
      //this.finishSampleLbl.isEmptySubCategory = false;
    } else {
      //this.finishSampleLbl.isEmptySubCategory = true;
      isValid = false;
    }
    return isValid;
  }
  public budgetReportGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'budget',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  public budgetReportGridSettings: GridSettings = {
    state: this.budgetReportGridstate,
    gridData: process(this.budgetReportGridData, this.budgetReportGridstate),
    columnsConfig: [{
      field: 'budget',
      title: 'Budget',
      filterable: true,
      widthForPDF: 40,
      _width: 110,
    },
    {
      field: 'cost',
      title: 'Cost',
      filterable: true,
      widthForPDF: 60,
      _width: 130,
    }
    ]
  };
  filterOnlybudgetReportItems(event) {
    if (event.target.checked)
      this.isonlybudgetReport = true;
    else
      this.isonlybudgetReport = false;
    this.getFilterbudgetReportItems();
  }
  filterInActivebudgetReportItems(event) {
    if (event.target.checked)
      this.isInActivebudgetReport = true;
    else
      this.isInActivebudgetReport = false;
    this.getFilterbudgetReportItems();
  }
  getFilterbudgetReportItems() {
    let totalbudgetReportItems: any[] = [];
    if (this.isonlybudgetReport && this.isInActivebudgetReport) {
      for (const [key, value] of Object.entries(this.totalbudgetReportGridData)) {
        if (value.currentInventory < value.budgetReportPoint)
          totalbudgetReportItems.push(value);
        if (value.isActive === false)
          totalbudgetReportItems.push(value);
      }
      this.budgetReportGridData = totalbudgetReportItems;
      this.loadbudgetReportHeaderGridData();
    }
    else if (this.isonlybudgetReport) {
      let onlybudgetReportItems: any[] = [];
      for (const [key, value] of Object.entries(this.totalbudgetReportGridData)) {
        if (value.currentInventory < value.budgetReportPoint)
          onlybudgetReportItems.push(value);
      }
      this.budgetReportGridData = onlybudgetReportItems;
      this.loadbudgetReportHeaderGridData();
    }
    else if (this.isInActivebudgetReport) {
      const dataList = this.totalbudgetReportGridData.filter(r => r.isActive === false);
      this.budgetReportGridData = dataList;
      this.loadbudgetReportHeaderGridData();
    }
    else {
      this.budgetReportGridData = this.totalbudgetReportGridData;
      this.loadbudgetReportHeaderGridData();
    }
  }

  

  private loadbudgetReportHeaderGridData(): void {
    if (this.budgetReportGridSettings.state)
      this.budgetReportHeaderGridData = process(this.budgetReportGridData, this.budgetReportGridSettings.state);
    else
      this.budgetReportHeaderGridData = process(this.budgetReportGridData, this.budgetReportGridstate);
    this.budgetReportGridSettings.gridData = this.budgetReportHeaderGridData;
  }
  protected budgetReportHeaderGridSortChange(sort): void {
    this.budgetReportGridstate.sort = sort;
    this.loadbudgetReportHeaderGridData();
  }

  protected budgetReportHeaderGridPageChange({ skip, take }: PageChangeEvent): void {
    this.budgetReportGridstate.skip = skip;
    this.budgetReportGridstate.take;
    this.loadbudgetReportHeaderGridData();
  }

  public budgetReportHeaderGridDataStateChange(state: DataStateChangeEvent): void {
    this.budgetReportGridstate = state;
    this.budgetReportGridSettings.state = this.budgetReportGridstate;
    this.loadbudgetReportHeaderGridData();
  }
  generateExcel() {
    this.loadingExcel = true;
    var currFilter = this.budgetReportGridSettings.state.filter;
    var filterData = process(this.budgetReportGridData, {
      filter: currFilter
    });
    var controls = this.budgetReportHeaderForm.controls;
    var toDate = formatDate(controls.startDate.value, 'MM/dd/yyyy', 'en');
    var fromDate = formatDate(controls.endDate.value, 'MM/dd/yyyy', 'en');
    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    //#region - format data based on column settings
    var titleOutput = [];
    var fieldOutput = [];
    this.budgetReportGridSettings.columnsConfig.filter(c => c.hidden != true).forEach(c => {
      titleOutput.push(c.title);
      fieldOutput.push(c.field);
    });
    //debugger;
    var dataArray: any[] = [];
    filterData.data.forEach(d => {
      dataArray.push(_.pick(d, fieldOutput));
    });
    //#endregion
    let worksheet = workbook.addWorksheet();
    const header = [this.budgetReportLblText.budgetlbl,
    this.budgetReportLblText.costlbl];
   
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow(['', '', this.budgetReportLblText.startDateLbl + ": " + toDate]);
    worksheet.addRow(['', '', this.budgetReportLblText.endDateLbl + ": " + fromDate]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    let orderDetailsRow = worksheet.addRow([this.budgetReportLblText.sampleProductLbl]);
    orderDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })

    dataArray.map(p =>
    ([
      p.budget ? p.budget : '',
      p.cost ? p.cost : '',
    ])
    )
      .forEach(d => {
        let row = worksheet.addRow(d);
      });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'SampleRequestBudgetReport.xlsx');
    })
    this.loadingExcel = false;
  }

  async generatePDF() {
    //debugger;
    this.loadingPDF = true;
    var currFilter = this.budgetReportGridSettings.state.filter;
    var filterData = process(this.budgetReportGridData, {
      filter: currFilter
    });
    var controls = this.budgetReportHeaderForm.controls;
    var toDate = formatDate(controls.startDate.value, 'MM/dd/yyyy', 'en');
    var fromDate = formatDate(controls.endDate.value, 'MM/dd/yyyy', 'en');
    //#region - format data based on column settings
    var titleOutput = [];
    var fieldOutput = [];
    var widthOutput = [];
    this.budgetReportGridSettings.columnsConfig.filter(c => c.hidden != true && c.widthForPDF > 0).forEach(c => {
      titleOutput.push(c.title);
      fieldOutput.push(c.field);
      widthOutput.push(c.widthForPDF);
    });
    //debugger;
    var dataArray: any[] = [];
    filterData.data.forEach(d => {
      dataArray.push(_.pick(d, fieldOutput));
    });
    //#endregion
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: this.budgetReportLblText.sampleProductLbl, alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          columns: [
            [{
              text: this.budgetReportLblText.startDateLbl + ": " + toDate,
              bold: true,
              margin: [0, 2, 0, 2]
            },
            {
              text: this.budgetReportLblText.endDateLbl + ": " + fromDate,
              bold: true,
              margin: [0, 2, 0, 2]
            }]
          ]
        },
        {
          text: "Sample Request Budget List",
          style: 'sectionHeader'
        },
        {
          style: 'tableStyle',
          table: {
            headerRows: 1,
            //widths: ['*'],
            widths: widthOutput,
            body: [
              [
                this.budgetReportLblText.budgetlbl,
                this.budgetReportLblText.costlbl
              ],
              ...filterData.data.map(p =>
              ([
                p.budget,
                p.cost
              ])
              )
            ]
          }
        }
      ],
      footer: {
        columns: [
          { text: '©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        headerLeft: {
          fontSize: 22,
        },
        headerRight: {
          fontSize: 22,
          alignment: 'center'
        },
        anotherStyle: {
          italics: true,
          alignment: 'right'
        },
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        tableStyle: {
          fontSize: 8
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('SampleRequestBudgetReport.pdf');
    this.loadingPDF = false;
  }
}
